module.exports = __webpack_public_path__ + "img/corrupted_annihilator_small.dce425a5.png";